// src/App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import KioskPage from "./pages/KioskPage";
import PhonePage from "./pages/PhonePage";
import CameraConfig from "./pages/CameraConfig";

function App() {
  return (
    <Router>
      <Routes>
        {/* Default route for kiosk */}
        <Route path="/kiosk" element={<KioskPage />} />
        {/* Phone page; expects a kioskId query parameter */}
        <Route path="/phone" element={<PhonePage />} />
        {/* Camera server route */}
        <Route path="/camera" element={<CameraConfig />} />
      </Routes>
    </Router>
  );
}

export default App;
